import { IonSpinner } from "@ionic/react";
import { useContext, useState } from "react";
import { ContainerSubirOrden } from "./localStyle";
import imageOrden from "../../../assets/images/generico/OrdenMiniatura.png";
import SubirIcon from "_+_Portal/assets/images/generico/SubirIcon";
import CameraIcon from "_+_Portal/assets/images/CameraIcon";
import { isNativeMobile } from "../../../../global/utils/platformDetector";
import { Camera, CameraResultType } from "@capacitor/camera";
import { PortalContext } from "_+_Portal/context/Provider";
import { wsPostSubirOrden } from "_+_Portal/context/Actions/ordenEstudio/ordenEstudio";
import { wsPostSubirOrdenLaboratorio } from "_+_Portal/context/Actions/ordenLaboratorio/ordenLaboratorio";

const SubirEditarOrden = ({ imageMod, turno, dissmiss }) => {
  //#region  ----------- useContext ---------------
  const {
    selectDropDownState,
    ordenEstudioDispatch,
    ordenLaboratorioDispatch,
  } = useContext(PortalContext);
  //#endregion  -------- useContext ---------------

  //#region  ----------- useState ---------------
  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState(false);
  const [ordenesPorSubir, setOrdenesPorSubir] = useState(imageMod);
  const [orden, setOrden] = useState({});
  //#endregion  -------- useState ---------------

  //#region ---------- constants ------------
  const isMobile = isNativeMobile();
  const familiarID = !selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.codigo
    ? false
    : selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.codigo;
  //#endregion ------- constants ------------

  //#region  ----------- funtions ---------------
  const getBinario = (orden, extension) => {
    const isPng = "data:image/png;base64,";
    const isJpg = "data:image/jpg;base64,";
    const isJpeg = "data:image/jpeg;base64,";
    let binario = "";

    switch (extension) {
      case "png":
        binario = orden.replace(isPng, "");
        break;
      case "jpg":
        binario = orden.replace(isJpg, "");
        break;
      default:
        binario = orden.replace(isJpeg, "");
    }
    return binario;
  };

  const nextStep = () => {
    setLoading(false);
    // if (listImagenes[index + 1]) {
    //   setIndex(index + 1);
    //   setImageMod(imageMod + 1);
    // } else {
    //   setIndex(-1);
    // }
  };

  const success = () => {
    setLoading(true);
    // if (idProtocolo) {
    //   wsDeleteOrdenLaboratorio(
    //     idProtocolo,
    //     elemento.idRemoto,
    //     nextStep
    //   )(ordenLaboratorioDispatch);
    // } else if (idturno) {
    //   wsDeleteOrdenEstudio(
    //     idturno,
    //     elemento.idRemoto,
    //     nextStep
    //   )(ordenEstudioDispatch);
    // }
  };
  const fail = () => {
    // if (listImagenes[index + 1]) {
    //   setIndex(index + 1);
    // } else {
    //   setIndex(-1);
    // }
  };
  const seleccionarImagen = (e) => {
    const value = e.target.value;
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        const binario = getBinario(
          reader.result,
          e.target.files[0].type.replace("image/", "")
        );
        const tag = e.target.files[0].type.replace("image/", "");
        const idremoto = turno?.idProtocolo ? turno.idProtocolo : turno.idturno;
        setOrden({ binario, tag, idremoto });
        setCurrent(reader.result);
      }
    };
    if (e.target.files[0]) {
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  const tomarFoto = () => {
    const takePicture = async () => {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.DataUrl,
      });
      const imageUrl = image.dataUrl;
    };
    takePicture();
  };

  const nextStepSubirOrden = () => {
    setLoading(false);
    if (ordenesPorSubir - 1 !== 0) {
      setCurrent(false);
      setOrden({});
      setOrdenesPorSubir(ordenesPorSubir - 1);
    } else {
      dissmiss();
    }
  };
  const onClickNo = () => {
    setOrden({});
    setCurrent(false);
  };
  const onClickSi = () => {
    if (!turno?.idProtocolo) {
      setLoading(true);
      wsPostSubirOrden([orden], nextStepSubirOrden)(ordenEstudioDispatch);
    } else {
      wsPostSubirOrdenLaboratorio(
        [orden],
        nextStepSubirOrden
      )(ordenLaboratorioDispatch);
    }
  };
  //#endregion  -------- funtions ---------------

  return (
    <ContainerSubirOrden>
      {!current ? (
        <>
          <span>Subir la imagen de el archivo </span>
          <img src={imageOrden} alt="Orden medica" />
          <div className="container-btn">
            <button
              className="btn btn-validaturno bgc-primary c-white rb14m"
              // onClick={subirOrden}
            >
              <SubirIcon />
              <span className="rb14m c-white">Subir</span>
              <input
                type="file"
                name="image-upload"
                id="input"
                accept="image/*"
                onChange={seleccionarImagen}
                className="autocheckin-absolute"
                autoComplete="off"
              />
            </button>
            {isMobile ? (
              <button
                className="btn btn-validaturno bgc-primary c-white rb14m"
                onClick={tomarFoto}
              >
                <CameraIcon />
                <span className="rb14m c-white">Tomar foto</span>
              </button>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        <>
          <span>¿El nuevo archivo se visualiza correctamente?</span>
          <img src={current} alt="Orden medica" />
          <div className="container-btn">
            <button
              onClick={onClickNo}
              className="btn btn-validaturno danger c-white rb14m btn-confirm"
            >
              NO
            </button>
            <button
              onClick={onClickSi}
              className="btn btn-validaturno success c-white rb14m btn-confirm"
            >
              {loading ? <IonSpinner name="lines" /> : "Si"}
            </button>
          </div>
        </>
      )}
    </ContainerSubirOrden>
  );
};

export default SubirEditarOrden;
